
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --sic-body-text--font-size:var(--body-02-font-size);
  --sic-body-text--line-height:var(--body-02-line-height);
}


.days-left{
  color:#e31937;
  font-weight:bold;
}


.text-container-wrapper{
  padding:var(--spacing-06);
}


@media (min-width: 1024px){


.text-container-wrapper{
    padding:var(--spacing-12)
}
  }


.text-content-wrapper{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  row-gap:var(--spacing-05);
}


@media (min-width: 1024px){


.text-content-wrapper{
    flex-direction:row;
    align-items:center;
    column-gap:var(--spacing-32)
}
  }


.content{
  height:100%;
  width:100%;
  z-index:1;
  background:var(--color-primary-lightest);
  border-radius:var(--border-radius-rounded-default);
  position:relative;
}


.text-wrapper{
  color:var(--color-neutral-default);
  text-align:right;
  display:flex;
  font-size:var(--body-02-font-size);
  flex-direction:column;
  flex-grow:1;
  align-items:flex-start;
  gap:var(--spacing-02);
  width:100%;
}


.cta{
  width:100%;
  display:block;
  flex-shrink:0;
}


@media (min-width: 768px){


.cta{
    width:auto
}
  }
`;